module.exports = __webpack_public_path__ + "img/Vegan Collagen Booster.00b7cbc9.jpg";